export default {
  登录: "Login",
  "请输入工号！": "Please enter your employee ID!",
  请输入工号: "Please enter your employee ID",
  "请输入密码！": "Please enter your password!",
  请输入密码: "Please enter your password",
  "7天免登录": "Remember me for 7 days",
  "忘记密码？": "Forgot password?",
  登录按钮: "Login",
  首次登录提示:
    "The initial password is: 123456. Please change your password after logging in!",
};
